import { render, staticRenderFns } from "./FooterTop.vue?vue&type=template&id=0647e041&scoped=true&"
import script from "./FooterTop.vue?vue&type=script&lang=js&"
export * from "./FooterTop.vue?vue&type=script&lang=js&"
import style0 from "./FooterTop.vue?vue&type=style&index=0&id=0647e041&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0647e041",
  null
  
)

export default component.exports